import React from 'react';
import { Typography } from '@mui/material';
import { toast, TypeOptions } from 'react-toastify';

export type ToastMessage = {
  title?: string;
  message?: unknown;
  error?: unknown;
  type?: TypeOptions;
};

function getMessageText(message: unknown): string | undefined {
  if (!message) {
    return undefined;
  }

  if (typeof message === 'string') {
    return message;
  }

  if (message instanceof Error) {
    return message.message;
  }

  if (typeof message === 'object') {
    const payload = message as Record<string, unknown>;
    const readableValue = payload.detail ?? payload.message ?? payload.title;

    if (typeof readableValue === 'string') {
      return readableValue;
    }

    try {
      return JSON.stringify(message);
    } catch {
      return String(message);
    }
  }

  return String(message);
}

export function displayMessage({ title, message, type = 'success' }: ToastMessage) {
  const text = getMessageText(message);

  if (title && text) {
    toast(
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography>{title}</Typography>
        <p>{text}</p>
      </div>,
      { type }
    );
  } else {
    toast(text || title, { type });
  }
}

export function errorMessage({ title, message, error }: ToastMessage) {
  const errorPayload =
    typeof error === 'object' && error && 'response' in error
      ? (error as { response?: { data?: unknown } }).response?.data
      : undefined;

  displayMessage({
    title,
    message: message ?? errorPayload ?? error,
    type: 'error',
  });
}
export function successMessage({ title, message }: ToastMessage) {
  displayMessage({ title, message, type: 'success' });
}

export function warningMessage({ title, message }: ToastMessage) {
  displayMessage({ title, message, type: 'warning' });
}
